// extracted by mini-css-extract-plugin
module.exports = {"pintxo-avatar":"Avatar_pintxo-avatar__wrfCS","pintxo-avatar__shape":"Avatar_pintxo-avatar__shape__BAKso","pintxo-avatar__shape__text":"Avatar_pintxo-avatar__shape__text___Wkwx"};